import { useCallback, useContext, useEffect, useMemo } from 'react'
import ContentfulWebPage from '../ContentfulWebPage'
import ModalContext from 'contexts/ModalContext'
import LuxAwardModal from './LuxAwardModal'
import { useHistory } from 'react-router'
import useQueryParams from 'hooks/useQueryParams'
import { useAppSelector } from 'hooks/reduxHooks'

const SUPPORTED_PATHS = [
  '/campaign/lux-list-travel-awards',
  '/campaign/lux-list-travel-awards-prizes',
  '/campaign/lux-list-travel-awards-us',
  '/campaign/lux-list-travel-awards-prizes-us',
  '/campaign/lux-list-travel-awards-uk',
  '/campaign/lux-list-travel-awards-prizes-uk',
]

function LuxAwardPage() {
  const pathname = useAppSelector((state) => state.router.location.pathname)
  const query = useQueryParams()
  const isModalOpen = query.get('modal_is_open') === 'true'
  const showModal = useContext(ModalContext)
  const history = useHistory()
  const openAwardModal = useCallback(async() => {
    await showModal(<LuxAwardModal />)
    const params = new URLSearchParams(history.location.search)
    params.delete('modal_is_open')
    const newSearch = params.toString()
    history.replace(`${history.location.pathname}${newSearch ? `?${newSearch}` : ''}`)
  }, [history, showModal])

  const shouldShowAwardModal = useMemo(() => isModalOpen && SUPPORTED_PATHS.filter(path => pathname.endsWith(path)).length > 0, [isModalOpen, pathname])

  useEffect(() => {
    if (shouldShowAwardModal) {
      openAwardModal()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShowAwardModal])

  return <ContentfulWebPage />
}

export default LuxAwardPage
